export default __webpack_public_path__ + "static/media/omar.34d6e8c9.jpg";